/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePortfolioVinRequest
 */
export interface CreatePortfolioVinRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioVinRequest
     */
    vin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioVinRequest
     */
    projectId?: string | null;
}

export function CreatePortfolioVinRequestFromJSON(json: any): CreatePortfolioVinRequest {
    return CreatePortfolioVinRequestFromJSONTyped(json, false);
}

export function CreatePortfolioVinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePortfolioVinRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}

export function CreatePortfolioVinRequestToJSON(value?: CreatePortfolioVinRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vin': value.vin,
        'projectId': value.projectId,
    };
}


